import type { CSSProperties } from 'react';

import type { ComponentClassNames } from '../../util/classNames';
import type { IRawStyle, ITheme } from '../../util/styling';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';
import { getDefaultTypographyStyles } from '../../util/theme/getGlobalComponentStyleOverrides.styles';

const boxSizingRootStyles: IRawStyle = {
  boxSizing: 'border-box',
};
const boxSizingChildStyles: IRawStyle = {
  boxSizing: 'inherit',
};

const getAppContainerStyles = (
  theme: ITheme,
  suppressGlobalStyles: boolean,
  useTransparentBackground: boolean
): IRawStyle => {
  const globalSelectorStyles: IRawStyle['selectors'] = suppressGlobalStyles
    ? {
        '*, *::before, *::after': boxSizingChildStyles,
      }
    : {
        ':global(html), :global(body)': {
          margin: 0,
          padding: 0,
        },
        ':global(html)': boxSizingRootStyles,
        ':global(html *), :global(html *::before), :global(html *::after)': boxSizingChildStyles,
      };

  return {
    ...(suppressGlobalStyles ? boxSizingRootStyles : {}),
    ...getDefaultTypographyStyles(theme, useTransparentBackground),
    selectors: globalSelectorStyles,
  };
};

type GetClassNamesMemoized = (
  theme: ITheme,
  suppressGlobalStyles: boolean,
  useTransparentBackground: boolean
) => ComponentClassNames<'appContainer'>;
export const getClassNames: GetClassNamesMemoized = memoizeFunction(
  (theme, suppressGlobalStyles, useTransparentBackground) =>
    mergeStyleSets({
      appContainer: getAppContainerStyles(theme, suppressGlobalStyles, useTransparentBackground),
    })
);

export const getFluent9ThemeProviderInlineStyles = (theme: ITheme, useTransparentBackground: boolean) =>
  getDefaultTypographyStyles(theme, useTransparentBackground) as CSSProperties;
